// extracted by mini-css-extract-plugin
module.exports = {"v-icon":"NsAddressPl_v-icon_1jzG8","nsAddressForm":"NsAddressPl_nsAddressForm_28TIm","dualColumn":"NsAddressPl_dualColumn_3U1xf","firstCol":"NsAddressPl_firstCol_iRuKB"};